import React from 'react'

function InvoiceStatus(status, paymentDate) {
  return(
    <React.Fragment>
      <center>
        {status == "PAID" && <span className="badge badge-success">Đã thanh toán
        {paymentDate && <small><br/>{paymentDate}</small>} 
        </span>}
        {status == "UNPAID" && <span className="badge badge-danger">Đang Chờ Thanh Toán</span>}
        {status == "INIT" && <span className="badge badge-warning">Đang Chờ Chấp Nhận</span>}
        {status == "REFUND" && <span className="badge bg-brown">Đã Hoàn Tiền</span>}
        {status == "NEW" && <span className="badge badge-info">Mới</span>}
        {status == "TRIAL" && <span className="badge bg-purple">Dùng Thử</span>}
        {status == "CANCEL" && <span className="badge badge-secondary">Hủy</span>}
      </center>
    </React.Fragment>
  )
}

export default InvoiceStatus;